import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Modal from "../Modal/Modal";
import flagMap from "../../../assets/utils/flagMap";
import { SUPPORTED_LANGUAGES } from "../../../i18n/i18n";
import { ALL_CURRENCIES, SUPPORTED_CURRENCY_IDS } from "../../../constants/currencies";
import "./LangCurrencyModal.css";

const ALL_LANGUAGES = [
  { code: "pl", name: "Polski", flagKey: "pl" },
  { code: "en", name: "English", flagKey: "us" },
  { code: "es", name: "Español", flagKey: "es" },
  { code: "de", name: "Deutsch", flagKey: "de" },
  { code: "fr", name: "Français", flagKey: "fr" },
  { code: "ru", name: "Русский", flagKey: "ru" },
];

const LANGUAGES = ALL_LANGUAGES.filter((lang) => SUPPORTED_LANGUAGES.includes(lang.code));
const CURRENCIES = ALL_CURRENCIES.filter((curr) => SUPPORTED_CURRENCY_IDS.includes(curr.code));

const LangCurrencyModal = ({
                             isOpen,
                             onClose,
                             currentLang,
                             currentCurrency,
                             onSelectLanguage,
                             onSelectCurrency,
                             initialTab = "language",
                           }) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(initialTab);

  const sortedLanguages = [...LANGUAGES].sort((a, b) =>
    a.code === currentLang ? -1 : b.code === currentLang ? 1 : 0
  );

  const sortedCurrencies = [...CURRENCIES].sort((a, b) =>
    a.code === currentCurrency ? -1 : b.code === currentCurrency ? 1 : 0
  );

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={t("header.preferences", "Preferences")}>
      {/* Tabs */}
      <div className="lc-tabs">
        <button
          type="button"
          className={`lc-tab-btn ${activeTab === "language" ? "active" : ""}`}
          onClick={() => setActiveTab("language")}
        >
          {t("header.language", "Language")}
        </button>
        <button
          type="button"
          className={`lc-tab-btn ${activeTab === "currency" ? "active" : ""}`}
          onClick={() => setActiveTab("currency")}
        >
          {t("header.currency", "Currency")}
        </button>
      </div>

      {/* Tab Content / List */}
      <div className="lc-list">
        {activeTab === "language"
          ? sortedLanguages.map((lang) => {
            const isSelected = lang.code === currentLang;
            const flagSrc = flagMap[lang.flagKey] || flagMap.generic;
            return (
              <button
                key={lang.code}
                type="button"
                className={`lc-item ${isSelected ? "selected" : ""}`}
                onClick={() => {
                  onSelectLanguage(lang.code);
                  onClose?.();
                }}
              >
                  <span className="lc-icon-circle">
                    <img src={flagSrc} alt={lang.name} className="lc-icon-img" />
                  </span>
                <span className="lc-item-label">{lang.name}</span>
                {isSelected && (
                  <span className="lc-item-check" aria-hidden="true">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <polyline points="20 6 9 17 4 12" />
                      </svg>
                    </span>
                )}
              </button>
            );
          })
          : sortedCurrencies.map((curr) => {
            const isSelected = curr.code === currentCurrency;
            return (
              <button
                key={curr.code}
                type="button"
                className={`lc-item ${isSelected ? "selected" : ""}`}
                onClick={() => {
                  onSelectCurrency(curr.code);
                  onClose?.();
                }}
              >
                <span className="lc-icon-circle lc-icon-circle--symbol">{curr.symbol}</span>
                <span className="lc-item-label">
                    {curr.code} — {curr.name}
                  </span>
                {isSelected && (
                  <span className="lc-item-check" aria-hidden="true">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <polyline points="20 6 9 17 4 12" />
                      </svg>
                    </span>
                )}
              </button>
            );
          })}
      </div>
    </Modal>
  );
};

export default LangCurrencyModal;
